import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { INPUT_SIZE } from "../../common/ThemeConstants";
import BasicFormComponent from "../../components/formComponent/BasicFormComponent";
import FormSelect from "../../components/general/FormSelect";
import FormTextField from "../../components/general/FormTextField";
import FormCheckbox from "../../components/general/FormCheckbox";
import DynamicContentGenerator from "./DynamicContentGenerator";

import {
  deleteRow,
  resetState,
  setFormFieldValue,
  setInitialState,
  setSearchFieldValue,
  submitForm,
} from "../../redux/actions/basicFormAction";
import { UPDATE_FORM_FIELD } from "../../redux/reduxConstants";
import { Button, Col, Row, Space, message } from "antd";
import { postRequest } from "../../services/mainApp.service";

const initialFormValues = {
  // OperationId: 1,
  // CompanyId: null,
  // CompanyName: "%%",
  // NoOfTerminals: null,
  // BusinessTypeId: null,
  // CompanyCode: "",
  // CountryId: null,
  // UserId: null,
  // UserIP: "",
  // EmailAddress: "",
  // // Contact1: "",
  // // Contact2: "",
  // // CompanyPocDetail: [],
  // IsEnabled: true,
  // OrderMode: "",
  // CompanyLogo: "",
  // Msg: "",

  OperationId: 1,
  CompanyId: null,
  // CompanyName: "%%",
  NoOfTerminals: null,
  // BusinessTypeId: null,
  // CompanyCode: "",
  // CountryId: null,
  UserId: null,
  UserIP: "",
  // CompanyLogo: "",
  EmailAddress: "",
  IsEnable: true,
  Msg: "",
  Contact1: "",
  Contact2: "",
  // CompanyPocDetail: [],
  // OrderMode: "",
  lstCompanySetting: [],
};
// i need data in this format
// "lstWebConfigurationSetting": [
//       {
//           "SetupDetailId": 234,
//           "Value": "100"
//       },
//       {
//           "SetupDetailId": 2,
//           "Value": "1"
//       }
//   ]

const initialSearchValues = {
  OperationId: 1,
  CompanyId: null,
  // CompanyName: "",
  NoOfTerminals: null,
  // BusinessTypeId: null,
  // CompanyCode: "",
  // CountryId: null,
  UserId: null,
  UserIP: "",
  // CompanyLogo: "",
  // EmailAddress: "",
  IsEnable: true,
  Msg: "",
  // Contact1: "",
  // Contact2: "",
  // CompanyPocDetail: [],
  // OrderMode: "",
};

// public int OperationId { get; set; }
// public int? CompanyId { get; set; }
// public string CompanyName { get; set; }
// public int NoOfTerminals { get; set; }
// public int BusinessTypeId { get; set; }
// public int CountryId { get; set; }
// public int UserId { get; set; }
// public string UserIP { get; set; }
// public string? CompanyLogo { get; set; }
// public string EmailAddress { get; set; }
// public bool IsEnable { get; set; }
// public string Msg { get; set; }

const columns = [
  {
    title: "Company Name",
    dataIndex: "CompanyName",
    key: "CompanyName",
  },
  {
    title: "Country",
    dataIndex: "CountryName",
    key: "CountryName",
  },
  {
    title: "Email",
    dataIndex: "EmailAddress",
    key: "EmailAddress",
  },
  {
    title: "Business Type",
    dataIndex: "BusinessTypeName",
    key: "BusinessTypeName",
  },
  {
    title: "Number of Terminals",
    dataIndex: "NoOfTerminals",
    key: "NoOfTerminals",
  },
  {
    title: "Enable",
    dataIndex: "IsEnabled",
    key: "IsEnabled",
  },
];
const CompanyEdit = () => {
  const {
    formFields,
    searchFields,
    formLoading,
    tableLoading,
    supportingTable,
  } = useSelector((state) => state.basicFormReducer);

  const dispatch = useDispatch();
  const controller = new window.AbortController();
  const userData = useSelector((state) => state.authReducer);
  const [updateId, setUpdateId] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [disableChecks, setDisableChecks] = useState(false);
  const [selectedOrderModes, setSelectOrderModes] = useState([]);
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [data, setData] = useState([]);
  let selectedImgUrl = "";

  // fields for dynamic content generator 
  const [formState, setFormState] = useState({});

  const handleChange = (id, value) => {
    setFormState((prev) => ({ ...prev, [id]: value.toString() }));
  };


  useEffect(async () => {
    const selectedCompany = userData?.companyList?.find(
      (company) => company.CompanyId === userData.CompanyId
    );

    // console.log("selectedCompany", selectedCompany);

    const payload = {
      OperationId: 1,
      CompanyId: userData?.CompanyId,
      UserId: userData?.UserId,
      UserIP: "12.1.1.12",

    };

    const response = await postRequest(
      "/CrudCompanyEdit",
      payload,
      controller,
    )

    setData(response?.data?.DataSet || []);



    return () => {
      controller.abort();
      dispatch(resetState());
    };
  }, []);

  function transformSettingsArrayToObject(settingsArray) {
    const result = {};

    settingsArray.forEach((item) => {
      const id = item.SetupDetailId.toString();

      if (item.Flex1 === "CHECKBOX") {
        result[id] = item.SettingValue;
      } else {
        result[id] = item.SettingValue;
      }
    });

    return result;
  }



  // const onImageChange = (e) => {
  //   selectedImgUrl = URL.createObjectURL(e.target.files[0]);
  //   setImage(e.target.files[0]);
  //   setImageUrl(selectedImgUrl);
  // };
  useEffect(() => {
    if (updateId !== null) {
      dispatch({
        type: UPDATE_FORM_FIELD,
        payload: data?.Table?.filter((item) => item.CompanyId === updateId)[0],
      });

      const formState = transformSettingsArrayToObject(data?.Table2 || []);
      setFormState(formState);
    }
    setUpdateId(null);
  }, [updateId]);

  const handleSearchChange = (data) => {
    dispatch(setSearchFieldValue(data));
  };

  const handleFormChange = (data) => {
    dispatch(setFormFieldValue(data));
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    // searchFields.CompanyName = searchFields.CompanyName.trim();
    // searchFields.OperationId = 1;
    // searchFields.CompanyId = userData.CompanyId;
    // // console.log(searchFields);

    const formData = new FormData();
    formData.append("OperationId", 1);
    formData.append("CompanyId", userData.CompanyId);
    formData.append("UserId", userData.UserId);
    formData.append("UserIP", "12.1.1.12");

    dispatch(
      setInitialState(
        "/CrudCompanyEdit",
        formData,
        initialFormValues,
        searchFields,
        controller,
        formData
      )
    );
  };

  const handleDeleteRow = (id) => {
    dispatch(
      deleteRow("/CrudCompanyEdit", { CompanyId: id }, controller, userData)
    );
  };

  const transformFormStateToApiFormat = (formState) => {
    return Object.entries(formState).map(([id, value]) => ({
      SetupDetailId: parseInt(id), // make sure it's a number
      Value: value?.toString() ?? "",
    }));
  };



  const handleFormSubmit = async (e, id, _, closeForm) => {
    e.preventDefault();

    // Prepare payload
    const payload = {
      OperationId: id,
      UserId: userData.UserId,
      CompanyId: userData?.CompanyId,
      UserIP: "12.1.1.12",
      IsEnable: formFields.IsEnable,
      OrderMode: selectedOrderModes.join(","),
      lstCompanySetting: transformFormStateToApiFormat(formState),
    };

    // Optionally remove 'CompanyLogo' if needed
    delete payload.CompanyLogo;

    const response = await postRequest(
      "/CrudCompanyEdit",
      payload, // JSON payload
      controller,
      () => {
        closeForm();
      },
      false
    );

    if (response?.error === true) {
      message.error(response?.errorMessage);
      return;
    } {
      message.success("updated successfully");
      setData(response?.data?.DataSet || []);
    }


  };



  const handleOrderModeChange = (name, obj) => {
    const copyOfSelectedOrderModes = selectedOrderModes;
    let orderModeIndex = selectedOrderModes.findIndex(
      (OrderModeName) => OrderModeName === name
    );
    if (orderModeIndex !== -1) {
      copyOfSelectedOrderModes.splice(orderModeIndex, 1);
    } else {
      copyOfSelectedOrderModes.push(name);
    }
    setSelectOrderModes([...copyOfSelectedOrderModes]);
    // setSelectOrderModes((prevMode) => {
    //   let orderModeIndex = prevMode.findIndex(
    //     (OrderModeName) => OrderModeName === name
    //   );
    //   if (orderModeIndex !== -1) {
    //     return prevMode.splice(orderModeIndex, 1);
    //   } else {
    //     return [...prevMode, name];
    //   }
    // });
  };
  const searchPanel = (
    <Fragment>
      <FormTextField
        colSpan={6}
        size={INPUT_SIZE}
        name="CompanyName"
        label="Company Name"
        value={searchFields.CompanyName}
        onChange={handleSearchChange}
      />

      {/* <FormSelect
        colSpan={6}
        label="Business Type"
        name="BusinessTypeId"
        listItem={supportingTable.Table1 || []}
        valueName="BusinessType"
        idName="BusinessTypeId"
        size={INPUT_SIZE}
        value={searchFields.BusinessTypeId}
        onChange={handleSearchChange}
        // required={true}
      /> */}
    </Fragment>
  );

  const formPanel = (
    <Fragment>
      <FormTextField
        colSpan={8}
        listItem={data.Table1 || []}
        size={INPUT_SIZE}
        name="CompanyName"
        label="Company Name"
        value={formFields.CompanyName}
        onChange={handleFormChange}
        disabled={true}
      />

      {/* <FormTextField
        colSpan={8}
        listItem={data.Table1 || []}
        size={INPUT_SIZE}
        name="EmailAddress"
        label="Email"
        value={formFields.EmailAddress}
        onChange={handleFormChange}
        disabled={true}
      />
      <FormSelect
        colSpan={6}
        label="Business Type"
        name="BusinessTypeId"
        listItem={data.Table1 || []}
        valueName="BusinessType"
        idName="BusinessTypeId"
        size={INPUT_SIZE}
        value={formFields.BusinessTypeId}
        onChange={handleFormChange}
        required={true}
      /> */}

      {/* <FormTextField
        colSpan={8}
        label="Number of Terminals"
        name="NoOfTerminals"
        size={INPUT_SIZE}
        value={formFields.NoOfTerminals}
        onChange={handleFormChange}
        required={true}
        type="number"
      /> */}
      {/* 
      <FormTextField
        colSpan={22}
        label="Message"
        name="Msg"
        size={INPUT_SIZE}
        value={formFields.Msg}
        onChange={handleFormChange}
      /> */}
      <FormCheckbox
        // colSpan={8}
        idName="id"
        valueName="name"
        name="IsEnable"
        label="Is Enabled"
        checked={formFields.IsEnable}
        onChange={handleFormChange}

      />

      <div className="w-full rounded-lg bg-gray-50">
        {/* todo  */}
        <DynamicContentGenerator
          settingsData={data?.Table2}
          formState={formState}
          handleChange={handleChange}
        />
      </div>
    </Fragment>
  );

  return (
    <BasicFormComponent
      formTitle="Company Edit"
      formPanel={formPanel}
      // searchPanel={searchPanel}
      searchSubmit={handleSearchSubmit}
      onFormSave={handleFormSubmit}
      tableRows={data?.Table || []}
      tableLoading={tableLoading}
      formLoading={formLoading}
      tableColumn={columns}
      deleteRow={handleDeleteRow}
      actionID="CompanyId"
      editRow={setUpdateId}
      fields={initialFormValues}
      crudTitle="Company"
      hideAddButton={true}
    />
  );
};

export default CompanyEdit;
